import { Fragment, useEffect, useRef, useState } from "react";
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, Icon, Label, TableCell, Popup } from "semantic-ui-react";

// Interfaces
import { ICONS } from "./sequence/MeCast";

// Style
import "./styles/TableMemberGroup.scss";

// Serializers
import PublishedDiagRuleWithNodeSerializer from "issara-sdk/types/PublishedDiagRuleWithNodeSerializer_apps_PRX";

// Types
import { MemberGroupListNodesItem, NodesMember } from "./MeCastType";
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";
import moment from "moment";

export type MockupMemberGroupSemantic = {
  id: number;
  groupName: string;
  total: number;
  children: { id: number; name: string; count: number }[];
  inactive?: boolean;
};

type TableMemberGroupProps = {
  data: PublishedDiagRuleWithNodeSerializer[];
  onEditNode: (
    group: PublishedDiagRuleWithNodeSerializer,
    node: MemberGroupListNodesItem
  ) => void;
};

const formatDataTime = (datetime?: string): string => {
  if (!datetime) return "";

  return moment(datetime).format("DD/MM/YYYY [[]HH:mm[]]");
};

const TableMemberGroup = (props: TableMemberGroupProps) => {
  const [activeIndexes, setActiveTabIndexes] = useState<number[]>([]);

  const handleClick = (index: number) => {
    setActiveTabIndexes(prev => 
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="table-member-group">
      <Table basic structured>
        {/* --- Header --- */}
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <label style={{ marginLeft: 30 }}>Group Name</label>
            </TableHeaderCell>
            <TableHeaderCell>
              <label style={{ display: "flex", justifyContent: "center" }}>Active Member(s)</label>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>

        {/* --- Body --- */}
        <TableBody>
          {props.data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={2}
                textAlign="center"
                style={{ padding: "20px", color: "#999", fontSize: "24px", height: "calc(55vh + 0.25rem)" }}
              >
                <img
                  src={ICONS.broadcast}
                  style={{
                    width: "50px",
                    height: "50px",
                    marginBottom: "-16px",
                    marginRight: "10px"
                  }}
                />
                <label>No Member Groups Found</label>
              </TableCell>
            </TableRow>
          ) : (
            <>
              {props.data.map((group, index) => {
                const isOpen = activeIndexes.includes(index);

                return (
                  <Fragment key={group.id}>
                    {/* --- Group Name --- */}
                    <TableRow
                      className="group-row"
                      // style={{ background: "#f7d9d9" }}
                      onClick={() => handleClick(index)}
                    >
                      <TableCell>
                        <Icon
                          name={isOpen ? "angle down" : "angle right"}
                          style={{ marginRight: 8 }}
                        />
                        <Popup
                          size="tiny"
                          basic
                          position="right center"
                          style={{ backgroundColor: "#fcbccd" }}
                          content={
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <label>Created by:</label>
                              <label>{group.created_by_name}</label>
                              <label>{formatDataTime(group.created)}</label>
                            </div>
                          }
                          trigger={<label>{group.diag_rule_name}</label>}
                        />

                        {!group.active && (
                          <Label color="grey" size="tiny" style={{ marginLeft: 10 }}>
                            Inactive
                          </Label>
                        )}
                      </TableCell>
                      <TableCell textAlign="right">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <strong style={{ color: "black" }}>
                            Total
                          </strong>
                          <strong style={{ color: "var(--primary-theme-color)" }}>
                            {group.total_member}
                          </strong>
                          <Icon
                            name="edit"
                            style={{ marginLeft: 8, opacity: 0 }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>

                    {/* --- Children Rows --- */}
                    {isOpen && group.nodes && group.nodes.map((item: MemberGroupListNodesItem, index: number) => (
                      <TableRow className="child-row" key={index}>
                        <TableCell style={{ paddingLeft: 40 }}>
                          {item.node_name}
                        </TableCell>
                        <TableCell textAlign="right">
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <strong style={{ color: "black", opacity: 0 }}>
                              Total
                            </strong>
                            <label>
                              {item.total_member}
                            </label>
                            {/* --- Edit --- */}
                            <Icon
                              name="edit"
                              style={{ marginLeft: 8, cursor: "pointer" }}
                              onClick={(e: MouseEvent) => {
                                e.stopPropagation();
                                props.onEditNode(group, item);
                              }}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </Fragment>
                )
              })}
            </>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default TableMemberGroup;